import { render, staticRenderFns } from "./SelectorClientAmenitiz.vue?vue&type=template&id=85b099da&scoped=true"
import script from "./SelectorClientAmenitiz.vue?vue&type=script&lang=js"
export * from "./SelectorClientAmenitiz.vue?vue&type=script&lang=js"
import style0 from "./SelectorClientAmenitiz.vue?vue&type=style&index=0&id=85b099da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b099da",
  null
  
)

export default component.exports